/*! License details at fancyapps.com/license */
const n=function(n="",t="",o=""){return n.split(t).join(o)};export{n as replaceAll};
